export const trimHash = (hash: string) => {
  if (hash.length > 20) {
    return hash.substring(0, 7) + '...' + hash.substring(hash.length - 5, hash.length);
  }
  return hash;
};
